export default "__VITE_ASSET___xTMx1PM__"